export default "__VITE_ASSET__Dd45pZWb__"